// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#login .container #login-row #login-column #login-box {\n  max-width: 600px;\n  border: 1px solid #555559;\n  background-color: #555559; }\n\n#login .container #login-row #login-column #login-box #login-form {\n  padding: 20px; }\n\n#login .container #login-row #login-column #login-box #login-form #register-link {\n  margin-top: -85px; }\n", ""]);
// Exports
module.exports = exports;
